import React from "react";

export default function WhatsAppFloat({
  phone = "923236625189",
  message = "Hi! I'm interested in your services.",
}) {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="cs_whatsapp_float"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <svg
        viewBox="0 0 32 32"
        width="28"
        height="28"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#FFFFFF"
          d="M16.003 3C9.374 3 4 8.373 4 15.003c0 2.645.864 5.09 2.323 7.06L4 29l7.16-2.277a11.93 11.93 0 0 0 4.843 1.013C22.627 27.736 28 22.363 28 15.003 28 8.373 22.627 3 16.003 3zm0 21.635a9.58 9.58 0 0 1-4.495-1.114l-.322-.169-4.248 1.35 1.387-4.134-.186-.338a9.6 9.6 0 1 1 7.864 4.405zm5.264-6.77c-.288-.145-1.702-.84-1.965-.936-.262-.095-.453-.145-.644.145-.19.29-.739.936-.906 1.13-.167.193-.334.217-.622.072-.288-.145-1.216-.448-2.317-1.428-.857-.763-1.436-1.705-1.604-1.995-.167-.29-.018-.446.126-.59.13-.13.289-.334.434-.502.144-.169.19-.29.289-.483.095-.193.047-.362-.024-.507-.071-.145-.644-1.553-.883-2.13-.233-.56-.469-.483-.644-.492l-.548-.01c-.19 0-.498.072-.758.362-.26.29-.996.973-.996 2.37 0 1.397 1.02 2.748 1.162 2.94.145.193 2.008 3.065 4.864 4.298.679.293 1.208.468 1.62.6.68.217 1.3.186 1.79.113.545-.081 1.702-.695 1.942-1.368.24-.672.24-1.248.168-1.368-.071-.121-.263-.193-.55-.338z"
        />
      </svg>
    </a>
  );
}
